import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { TransactionListStartedAtCell } from './transaction-list-started-at.cell';
import { TransactionListStartedAtHeader } from './transaction-list-started-at.header';

export const TransactionListStartedAtColumn: IdentifiedColumnDef<
  TransactionModel,
  TransactionModel['startedAt']
> = {
  enableSorting: true,
  header: TransactionListStartedAtHeader,
  cell: TransactionListStartedAtCell,
  meta: { maxWidth: '165px', width: '160px', minWidth: '60px' },
};
